import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemePreset, applyThemeTokens } from '../../theme/themeEngine';

interface ThemeContextValue {
  theme: ThemePreset;
  setTheme: (theme: ThemePreset) => void;
}

const ThemeContext = createContext<ThemeContextValue | null>(null);

export const ThemeProvider: React.FC<{ children: React.ReactNode; initialTheme?: ThemePreset }> = ({
  children,
  initialTheme = 'midnight',
}) => {
  const [theme, setThemeState] = useState<ThemePreset>(initialTheme);

  const setTheme = (nextTheme: ThemePreset) => {
    setThemeState(nextTheme);
    applyThemeTokens(nextTheme);
  };

  useEffect(() => {
    applyThemeTokens(theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextValue => {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    return {
      theme: 'midnight',
      setTheme: (t) => applyThemeTokens(t),
    };
  }
  return ctx;
};
